import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MaintenanceError } from "../../common/errors/MaintenanceError";
import { GtagService } from "../../gtag/gtag.service";
import { AuthService } from "../auth.service";

@Component({
    selector: 'app-passwd',
    templateUrl: './passwd.component.html',
    styleUrls: ['./passwd.component.css'],
    standalone: false
})
export class PasswdComponent implements OnInit {
  login!: string;

  constructor(private authService: AuthService, private router: Router, private gtag: GtagService) {
    this.gtag.pageview2('Restore password');
  }

  ngOnInit() {
  }

  resetPasswd() {
    const subscr = this.authService.resetPassword(this.login).subscribe({
      next: () => {
        alert("Ссылка на восстановление пароля выслана на Ваш email");
        this.router.navigate(["/login"]);
      },
      error: (e: any) => {
        subscr.unsubscribe();
        if (e instanceof MaintenanceError) {
          alert(e.message);
          window.location.href = '/';
          return;
        }

        const err = JSON.parse(e.message);
        switch (err.error) {
          case 'no_user_found':
            alert('Пользователь не зарегистрирован');
            break;
          case 'no_email_found':
            alert('У пользователя отсутствует email адрес');
            break;
          default:
            alert(err.error);
        }
      },
      complete: () => {
        subscr.unsubscribe();
      }
    });
  }

}
